export default {
  fullname: 'Hong Kong Legal Information Institute',
  subheading: 'Free access to legal information in Hong Kong',
  lawtech: 'Managed by the Law and Technology Centre, Faculty of Law, The University of Hong Kong',
  news_1_title: "Welcome to the Upgraded HKLII",
  news_1_intro: "Hong Kong Legal Information Institute (HKLII) is pleased to announce the launch of our upgraded website. Do check out our {0} for a quick introduction to its new features. You will find the following new features and improvements:",
  news_1_content: [
    "Your comments are highly appreciated. Do take a minute to fill out the {0} at the bottom right corner of the website, or write to us using the {1}. We would like to take this opportunity to thank our Beta testers for their insightful comments and suggestions throughout the testing phrase.",
    "HKLII seeks to provide free and easy access to legal information with intelligent features  powered by AI technology in the years ahead. Please consider supporting the service by making a {0} to us. All {1} are duly acknowledged on our donors page."
  ],
  news_1_newfeature: [
    "Search by parallel citations",
    "Support of parallel citations in Noteup function",
    "Improvement in search by neutral citations and action numbers",
    "Dynamically updated case history and appeal history",
    "Improvement in definition markup & linking accuracy",
    "Simplified Chinese legislation documents",
    "Quick link to e-legislation",
    "Responsive interface for smaller devices",
    "Improved formatting for Judgments and Legislation contents",
  ],
  news_1_subhead: [
    "Comments invited",
    "Support a smarter HKLII"
  ],
  news_1_donation: "donation",
  news_1_thankdonor: "donors",
  news_2_title: "Hong Kong Company Law Cases (HKCLC) citation is now available on HKLII",
  news_2_content: [
    'We now provide Hong Kong Company Law Cases (HKCLC) citation. The information is listed at "Parallel Cit." within the "Judgment Information" box on the left side of Judgments. You can search for relavant judgments (e.g. [2022] HKCLC 715) via our search bar.',
    "HKCLC is a series of law reports that provide coverage of company law cases in Hong Kong and oversea company law cases involving Hong Kong companies."
  ],
  news_3_title: "HKLII Migration Notice",
  news_3_content: [
    "Starting 16 June 2023, you will be able to access this upgraded version of HKLII via {0}. The current address v2.hklii.hk will remain in service. ",
    "Should you wish to visit the older version of HKLII, please use {0}.",
    "We thank you for your continued support and please direct any comments or questions to {0}.",
  ],
  news_4_title: "AI-powered features added to HKLII",
  news_4_intro: [
    "Over the past 2 years the research and development teams at HKLII have worked hard to bring new functions to the platform. We are pleased to announce that our latest efforts have culminated in the deployment of AI-powered features to make legal research on the platform more efficient.",
    "Added features are denoted with a {0} label. For a detailed overview of these features, please visit our {1} page. New features include:",
    "We have also launched a new tool {0} for users to browse for statistics of drug trafficking and personal injuries cases.",
  ],
  news_4_content: [
    "We would like to take this opportunity to thank all our Beta testers for their time and insights that have made the delivery possible. And as always, we welcome your {0} and suggestions to continue improving our platform.",
    "We hope these new features will enhance your research experience. Thank you for choosing HKLII as your legal research tool.",
  ],
  news_4_newfeature: [
    "Smart search categorisation and suggestion",
    "Case Info boxes for drug trafficking and personal injuries cases",
    "Similar Judgment Search for personal injuries cases",
    "Case Summary for personal injuries cases",
  ],  
  ratingbox: "rating box",
  feedbackfrom: "feedback form",
  feedbackpage: "our feedback page",
  sitetour: "site tour",
  signoff: "The HKLII Team",
  chi_signoff: "",
  donatecard_title: "Support Us for a Better HKLII, and Better Legal Research",
  donatecard_content: "HKLII is working hard to make law publicly accessible.  In 2020, HKLII began redeveloping the 20-year-old website to modernise the interface and add more functionalities to enhance users’ legal research experience. Yes, the pandemic didn't stop us. We will keep moving forward to provide free access to legal information with more intelligent features. We have our donors to thank for that. We hope you will support us by joining them and making a {0} to us. Our goal for the coming years is to raise one million dollars and to incorporate AI techniques into HKLII.",
  falm_intro:"HKLII provides free access to legal information in Hong Kong and participates in the Free Access to Law Movement.",
  advanced_desc: 'Formulate searches with targeted fields and databases',
  simple_desc: 'You can use operators (AND, NEAR, tax*, "moral rights", etc.) <br/>in this box to search for any content on the site, e.g.: <li>Cap Number (599J)</li><li>Judgments (neck sprain NEAR numbness)</li><li>Parallel citations ([2001] 1 HKLRD 1)</li><li>Legal concepts (procedural impropriety)</li><li>People (Chief Justice AND Andrew Li)</li>',
  announcements: 'News',
  news: 'Latest Uploaded Judgments of CFI, CA and CFA',
  case_summary:'View Summary',
  case_summary_desc:'Quickly grasp key facts of this case. Please note that Chinese judgments are not yet supported.',
  shortcut_hint:'This section will remain open (or closed) on this device if clicked on',
  judgments: ' Judgments',
  judgments_altlang: '', //'Chinese Judgments'
  legislation: 'Legislation',
  copyright: 'Copyright',
  crinfo: 'Hong Kong Legal Information Institute (HKLII)',
  news_4_bookmarks: [
    'search',
    'infobox',
    'tagging',
    'casesummary'
  ],
  run_by: 'Run By',
  manage_by: 'Managed By',
}
